import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import { Broker } from '@c4/core';
import * as moment from 'moment';

const STORE_NAME: string = 'SYSMAN';
const SET_CONNECTION: string = STORE_NAME + ':SET_CONNECTION';
const SET_HOST: string = STORE_NAME + ':SET_HOST';
const SYSMAN_WORKING: string = STORE_NAME + ':WORKING';

export const INITAL_CONNECTED_STATE: any = {
  working: false,
  host: '',
  connectedDevice: {}
};

export function connectedDeviceReducer(state: any = INITAL_CONNECTED_STATE, {type, payload}) {
  switch (type) {
    case SET_CONNECTION:
      return Object.assign({}, state, payload);

    case SET_HOST:
      return Object.assign({}, state, { host: payload });

    case SYSMAN_WORKING:
      return Object.assign({}, state, { working: payload });

    default:
      return state;
  }
};

@Injectable()
export class ConnectedDeviceService {

  isConnected: boolean;
  brokerHost: string;
  
  constructor(private store: Store<any>, private broker: Broker) {
    this.isConnected = false;
  }

  // set this on initial connection to broker
  setHost(ip : string) {
    console.log('connecteddeviceservice: set host', ip);
    this.brokerHost = ip;
    this.store.dispatch({ type: SET_HOST, payload: ip });
  }

  setConnection(conn: any) {
    console.log('connecteddeviceservice: set connection', conn);
    conn.uptime = null;
    this.store.dispatch({ type: SET_CONNECTION, payload: { connectedDevice: conn } });
    this.isConnected = true;

    // get uptime - only works on broker host
    if (this.brokerHost == conn.address) {
      this.getDeviceUptime().then(
        (uptimeVal:any) => {
          console.log("controller uptime:", uptimeVal);
          if (uptimeVal) {
            conn.uptime = this.humanizeDuration(uptimeVal.bootTime, uptimeVal.currentTime);
            this.store.dispatch({ type: SET_CONNECTION, payload: { connectedDevice: conn } });
          }
        },
        (err:any) => {
          conn.uptime = null;
        }
      );
    }
  }

  setWorking(state: boolean) {
    this.store.dispatch({ type: SYSMAN_WORKING, payload: state });
  }

  public getDeviceUptime = (ip?: string): Promise<any> => {
    return new Promise((resolve: (response: any) => any, reject: (error: any) => any) => {
      let request: any = {
        method: 'GET',
        path: '/api/v1/stats'
      };
      this.broker.call(request).then(
          (response: any) => {
              resolve(response);
          },
          (error: any) => {
              reject(error);
          });
      });
  }

  // JS Date format strings - ie "2017-04-06T11:10:12.000Z"
  humanizeDuration(startdate: string, enddate: string) : string {

    let dt1:any = new Date(startdate);
    let dt2:any = new Date(enddate);
    let diff = moment.duration(dt2 - dt1); //ms
    let durationStr = "";

    if (diff.years() > 0)
      durationStr = diff.years() + "Y ";
    if ((durationStr.length > 0) || (diff.months() > 0))
      durationStr += diff.months() + "M ";
    if ((durationStr.length > 0) || (diff.days() > 0))
      durationStr += diff.days() + "D ";
    if ((durationStr.length > 0) || (diff.hours() > 0))
      durationStr += diff.hours() + "H ";
    if ((durationStr.length > 0) || (diff.minutes() > 0))
      durationStr += diff.minutes() + "M ";
    if ((durationStr.length > 0) || (diff.seconds() > 0))
      durationStr += diff.seconds() + "S ";
    
    return durationStr;
  }

  // return icon class based on uuid
  getIconClass(uuid : string) {
    if (uuid) {
      if ((uuid.indexOf("home-controller") > -1) || (uuid.indexOf("ea") == 0))
        return "controller";
      else
        if ((uuid.indexOf("glassedge") > -1) || (uuid.indexOf("bcm-") > -1) || (uuid.indexOf("touchpanel-") > -1))
          return "touch-screen";
        else
          if (uuid.indexOf("xtender") > -1)
            return "io-extender";
          else
            return "controller";
    }
    else
      return "controller";
  }

  isValidIPAddress(ip : string) {
    if ((ip != '0.0.0.0') && (ip != '255.255.255.255')) {
        let regex =/\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\b/;
        return regex.test(ip);
    }
    return false;
  }  
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/connected-device.service.ts